import { render, staticRenderFns } from "./view-section-title.vue?vue&type=template&id=bf7e6f9a&"
import script from "./view-section-title.vue?vue&type=script&lang=js&"
export * from "./view-section-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports